import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const EMOTICON_SIZE = 48;

type ScoreProps = {
  store?: boolean;
};

export const Score = styled.div<ScoreProps>(
  p => css`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    font-size: 24px;
    line-height: normal;
    color: ${p.theme.text.primary};

    ${!p.store &&
      css`
        margin-left: ${layout.spacing.xSmall};
        margin-right: ${layout.spacing.xxSmall};
      `};

    ${p.store &&
      css`
        align-self: flex-start;
      `}
  `
);

export const Divider = styled.span`
  &::after {
    margin: 0 ${layout.spacing.xSmall};
    content: '•';
  }
`;

type FirstToReviewTextProps = {
  marginLeft?: boolean;
};

export const FirstToReviewText = styled.div<FirstToReviewTextProps>`
  color: ${p => p.theme.text.primary};
  margin-left: ${p => (p.marginLeft ? layout.spacing.xSmall : 0)};
`;

export const Rating = styled.div``;

export const Count = styled.div``;

export const ProductRating = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  column-gap: ${layout.measurements.spacingTiny};

  ${Score} {
    grid-area: 1 / 1 / 2 / 2;
    align-self: start;
    font-size: ${layout.measurements.fontSizeMega};
  }

  ${Rating} {
    grid-area: 1 / 2 / 2 / 3;
    align-self: center;
  }

  ${Count} {
    grid-area: 2 / 2 / 3 / 3;
  }
`;

export const ShopRating = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  column-gap: ${layout.measurements.spacingSmall};

  ${Rating} {
    grid-area: 1 / 1 / 3 / 2;
  }

  ${Score} {
    grid-area: 1 / 2 / 2 / 3;
  }

  ${Count} {
    grid-area: 2 / 2 / 3 / 3;
  }
`;
